/*# sourceMappingURL=medical-alert.component-JNF4XVX6.css.map */
